<div class="wrapper">
  <div class="action-section flex flex-row-reverse my-[20px] w-full gap-[20px]">
    @if (!role?.startsWith('contractor') && canCreate) {
      <app-primary-button (handleClick)="createItem()" class="!w-[150px]">
        New Item
      </app-primary-button>
    }

    <div class="item-filters flex flex-row gap-[20px] flex-1 mt-[7px]">
      @if (punchlist?.name) {
        <div
          #punchlistTrigger="cdkOverlayOrigin"
          (click)="openPunchlistPicker()"
          [class.static]="!(punchlists?.length > 1)"
          cdkOverlayOrigin
          class="filter-button punchlist-filter flex flex-row items-center gap-[8px]">
          <div [title]="punchlist.name" class="label text-type-8 punchlist-trigger">Punch list: {{ punchlist.name }}</div>
          @if (punchlists?.length > 1) {
            <mat-icon class="chevron">expand_more</mat-icon>
          }
        </div>

        <ng-template
          (backdropClick)="punchlistPickerOpen = false"
          [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
          [cdkConnectedOverlayHasBackdrop]="true"
          [cdkConnectedOverlayOpen]="punchlistPickerOpen"
          [cdkConnectedOverlayOrigin]="punchlistTrigger"
          cdkConnectedOverlay
        >
          <div class="status-filter-popup punchlist-popup">
            @for (p of punchlists; track (p.uuid || p.id)) {
              <div
                (click)="selectPunchlist(p)"
                [class.selected]="(p.uuid || p.id) === (punchlist?.uuid || punchlist?.id)"
                [title]="p.name"
                class="punchlist-option text-type-8">
                {{ p.name }}
              </div>
            }
          </div>
        </ng-template>
      }

      <app-status-filter [statusOptions]="statusList" />

      <div>
        @if (selectedSortColumn) {
          <mat-form-field class="sort-dropdown">
            <mat-select
              (selectionChange)="onSortColumnChange($event)"
              [(value)]="selectedSortColumn"
              disableOptionCentering
              panelClass="item-sort-panel">
              <mat-select-trigger>
                Sort by: {{ sortLabels[selectedSortColumn] || selectedSortColumn }}
              </mat-select-trigger>
              @for (column of sortByColumns; track column) {
                <mat-option [value]="column">{{ sortLabels[column] || column }}</mat-option>
              }
            </mat-select>
            <mat-icon (click)="removeSort($event)" class="sort-close" matSuffix>close</mat-icon>
          </mat-form-field>
        }
        @if (!selectedSortColumn) {
          <div (click)="openSortDropdown($event)" class="sort-dropdown nosort">
            <div class="label text-type-8">Sort:</div>
            <mat-icon>sync_alt</mat-icon>
            <mat-form-field class="sr-sort-hidden">
              <mat-select
                #sortSelect
                (selectionChange)="onSortColumnChange($event)"
                [(value)]="selectedSortColumn"
                disableOptionCentering
                panelClass="item-sort-panel">
                @for (column of sortByColumns; track column) {
                  <mat-option [value]="column">{{ sortLabels[column] || column }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        }
      </div>

      <div class="search-section flex flex-1 flex-row gap-[10px] min-w-0">
        <form [formGroup]="form" class="flex-1 min-w-0">
          <div class="search w-full">
            <mat-icon svgIcon="search"></mat-icon>
            <input
              class="search-input"
              formControlName="searchText"
              matInput
              placeholder="Search"
            />
            @if (form?.controls?.['searchText']?.value) {
              <mat-icon (click)="clearSearch()" svgIcon="close"></mat-icon>
            }
          </div>
        </form>
      </div>
    </div>
  </div>

  <div class="items-list-table flex flex-col gap-[40px]">
    @if ((loading && !items.length) || !fields) {
      <div class="no-data text-type-8 mt-[40px]">Loading…</div>
    } @else if (items.length) {
      <div class="bit-items-table">
        <table [dataSource]="items" class="mat-elevation-z8 table" mat-table>
          <ng-container matColumnDef="item_number">
            <th *matHeaderCellDef mat-header-cell>
              <span class="th-text">Item #</span>
            </th>
            <td *matCellDef="let row" mat-cell>
              <div class="text-type-8">{{ row?.item_number }}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="title">
            <th *matHeaderCellDef mat-header-cell>
              <span class="th-text">{{ fieldByName.title?.label || 'Title' }}</span>
            </th>
            <td *matCellDef="let row" mat-cell>
              <div class="text-type-8">{{ row?.title }}</div>
              @if (fieldByName.description) {
                <div class="description text-type-14">{{ row?.description }}</div>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="category">
            <th *matHeaderCellDef mat-header-cell>
              <span class="th-text">{{ fieldByName.category?.label || 'Category' }}</span>
            </th>
            <td *matCellDef="let row" mat-cell>
              <div class="text-type-11">{{ valuesText(row, 'category') || '—' }}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="severity">
            <th *matHeaderCellDef mat-header-cell>
              <span class="th-text">{{ fieldByName.severity?.label || 'Severity' }}</span>
            </th>
            <td *matCellDef="let row" mat-cell>
              @if (row?.severity && severityMap[row.severity]) {
                <div class="status-chip-container">
                  <div
                    [ngClass]="[severityMap[row.severity].bgColor, severityMap[row.severity].textColor]"
                    class="status-chip px-[14px] rounded-full">
                    {{ severityMap[row.severity].label }}
                  </div>
                </div>
              } @else {
                <div class="text-type-11">{{ row?.severity || '—' }}</div>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th *matHeaderCellDef mat-header-cell>
              <span class="th-text">Status</span>
            </th>
            <td *matCellDef="let row" mat-cell>
              @if (statusMap[row?.status]) {
                <div class="status-chip-container">
                  <div
                    [ngClass]="[statusMap[row.status].bgColor, statusMap[row.status].textColor]"
                    class="status-chip px-[14px] rounded-full">
                    {{ statusMap[row.status].label }}
                  </div>
                </div>
              } @else {
                <div class="text-type-11">{{ row?.status }}</div>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="need_by_date">
            <th *matHeaderCellDef mat-header-cell>
              <span class="th-text">{{ fieldByName.need_by_date?.label || 'Need By' }}</span>
            </th>
            <td *matCellDef="let row" mat-cell>
              <div class="text-type-11">{{ row?.need_by_date ? (row.need_by_date | date:'MMM d, y') : '—' }}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="created_by">
            <th *matHeaderCellDef mat-header-cell>
              <span class="th-text">Created By</span>
            </th>
            <td *matCellDef="let row" mat-cell>
              <div class="text-type-11">
                {{ row?.createdBy ? ((row.createdBy.first_name || '') + ' ' + (row.createdBy.last_name || '')).trim() || row.createdBy.email : '—' }}
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="created_at">
            <th *matHeaderCellDef mat-header-cell>
              <span class="th-text">Created</span>
            </th>
            <td *matCellDef="let row" mat-cell>
              <div class="text-type-11">{{ row?.created_at | date:'MMM d, y' }}</div>
            </td>
          </ng-container>

          <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
          <tr
            (click)="rowClicked(row)"
            *matRowDef="let row; columns: displayedColumns"
            [class.highlighted-row]="row === selectedRow"
            class="cursor-pointer"
            mat-row
          ></tr>
        </table>
      </div>
    } @else {
      <div class="no-data text-type-8 mt-[80px]">No punch items found.</div>
    }
    @if (totalRecords > pagination.pageSize) {
      <app-paginator
        (pageChanged)="onPageChanged($event)"
        [itemsPerPage]="pagination.pageSize"
        [maxVisiblePages]="5"
        [totalItems]="totalRecords"
        class="paginator"
        />
    }
  </div>
</div>
